import * as React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserHistory } from 'history';

import App from './App';
import { AppContextProvider, AssessmentContextProvider } from './context';
import CustomRouter from './CustomRouter';

const history = createBrowserHistory();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
	<CustomRouter history={history}><AppContextProvider>
		<AssessmentContextProvider>
			<App  history={history}/>
		</AssessmentContextProvider>
	</AppContextProvider></CustomRouter>);
